import InputTypesEnum from "../../../Enums/InputTypesEnum";
import IobLineItemSearchParams from "./IobLineItemSearchParams";

export default class IobLineItemTransactionAdminSearchParams extends IobLineItemSearchParams {

    static fieldsInSearchBox = [
        { fieldName: "ExportPaymentId", label: "Export Payment ID", className: "col-4", type: InputTypesEnum.Text },
		{ fieldName: "Type", label: "Type", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getSelectValuesForType() },
		{ fieldName: "SelectedEvaluatorCountries", label: "Country", className: "col-4", type: InputTypesEnum.CountryMultiChoice },
		{ fieldName: "ExportId", label: "Export ID", className: "col-4", type: InputTypesEnum.Text },
    ];
}